import { createFileRoute, redirect } from '@tanstack/react-router'
import { CustomerListView } from '@/features/customers/customers'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/customers/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'customer.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: CustomerListView,
})
